import React from "react";
import PropTypes from "prop-types";

function Button({
  className,
  type,
  size,
  bgColor,
  color,
  minWidth,
  label,
  onClick,
  disabled
}) {
  const styles = {};
  const classNames = ["pw-button"];

  // Apply dynamic color
  if (color) styles.color = color;
  if (bgColor)
    styles[type === "outlined" ? "borderColor" : "backgroundColor"] = bgColor;
  if (minWidth) styles.minWidth = minWidth;
  if (disabled) styles.pointerEvents = "none";
  if (disabled) classNames.push("pw-button--disabled");

  // Apply classNames
  if (type === "outlined") classNames.push("pw-button__outlined");
  if (type === "earn") classNames.push("pw-button__earn-footer-btn");
  if (size === "large") classNames.push("pw-button__large");
  if (type === "outlined" && size === "large")
    classNames.push("pw-button__outlined__large");
  if (type === "disabled") classNames.push("pw-button__disabled");
  if (type === "pending") classNames.push("pw-button__pending");
  if (type === "earn-coins") classNames.push("pw-button__earn");
  if (type === "contact") classNames.push("pw-button__contact");

  if (className) classNames.push(className);

  return (
    <button className={classNames.join(" ")} style={styles} onClick={onClick}>
      {label}
    </button>
  );
}

Button.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
  size: PropTypes.string,
  color: PropTypes.string,
  bgColor: PropTypes.string,
  minWidth: PropTypes.string,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

export default Button;
